import { render } from "./AddPiecePage.vue?vue&type=template&id=6b636b83&ts=true"
import script from "./AddPiecePage.vue?vue&type=script&lang=ts"
export * from "./AddPiecePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__